// main.js
import { createApp } from 'vue'; // 使用 createApp 创建应用实例
import App from './App.vue';
import '@fortawesome/fontawesome-free/css/all.min.css';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import zhCn from 'element-plus/es/locale/lang/zh-cn'; // 引入中文语言包
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn'; // 引入 dayjs 的中文语言包
import router from './router';
import store from './store'; // 引入 Vuex store

// 设置 dayjs 语言
dayjs.locale('zh-cn');

const app = createApp(App);

// 使用 ElementPlus 并设置语言
app.use(ElementPlus, {
  locale: zhCn,
});

// 使用路由
app.use(router);

// 使用 Vuex store
app.use(store);

store.dispatch('checkToken').then(() => {
  app.mount('#app');
});